import {
  CustomMappingStatus,
  CustomMappingType,
  type ICustomMapping,
} from '@principle-theorem/practice-migrations/interfaces';
import { type AtLeast } from '@principle-theorem/shared';

export const CUSTOM_MAPPING_STATUS_MAP: {
  [key in CustomMappingStatus]: string;
} = {
  [CustomMappingStatus.Unlocked]: 'default',
  [CustomMappingStatus.Locked]: 'primary',
};

export class CustomMapping {
  static init(
    overrides: AtLeast<ICustomMapping, 'metadata' | 'type'>
  ): ICustomMapping {
    if (overrides.type !== CustomMappingType.SingleValue) {
      return {
        uid: overrides.metadata.type,
        status: CustomMappingStatus.Unlocked,
        ...overrides,
      };
    }

    if (overrides.inputType === 'select') {
      return {
        uid: overrides.metadata.type,
        status: CustomMappingStatus.Unlocked,
        placeholder: '',
        hint: '',
        inputType: 'text',
        options: [],
        ...overrides,
      };
    }

    return {
      uid: overrides.metadata.type,
      status: CustomMappingStatus.Unlocked,
      placeholder: '',
      hint: '',
      ...overrides,
    } as ICustomMapping;
  }
}
